module.exports = __webpack_public_path__ + "img/robot_face.4e1391cf.png";